<script setup lang="ts">
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { SankeyChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import { ref } from 'vue';

const props = defineProps<{
	data: {
		nodes: unknown[];
		links: unknown[];
	};
}>();
const sankeyColors = ['#fc9f9d', '#d0999f', '#b295a2', '#8f90a5'];
const sankeyLineStyle = {
	color: 'gradient',
	opacity: 0.6,
};
const sankeyLevels = [
	{
		depth: 0,
		itemStyle: {
			color: sankeyColors[0],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 1,
		itemStyle: {
			color: sankeyColors[1],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 2,
		itemStyle: {
			color: sankeyColors[2],
		},
		lineStyle: sankeyLineStyle,
	},
	{
		depth: 3,
		itemStyle: {
			color: sankeyColors[3],
		},
		lineStyle: sankeyLineStyle,
	},
];

use([CanvasRenderer, SankeyChart, TitleComponent, TooltipComponent]);

const option = ref({
	title: {
		text: props.data.title,
	},
	tooltip: {
		trigger: 'item',
		triggerOn: 'mousemove',
	},
	series: [
		{
			type: 'sankey',
			data: props.data.nodes,
			links: props.data.links,
			label: {
				color: '#000',
				overflow: 'truncate',
				ellipsis: '...',
				width: 150,
				hideOverlap: true,
			},
			emphasis: {
				focus: 'adjacency',
			},
			levels: sankeyLevels,
			lineStyle: {
				curveness: 0.5,
			},
			top: '10%',
			bottom: '15px',
			right: '150px',
			left: 0,
		},
	],
});
</script>
<template>
	<div class="flex justify-center flex-col items-center">
		<v-chart
			v-if="props.data.nodes && props.data.links"
			class="chart"
			:option="option"
			autoresize
			:init-options="{ width: 800, height: 320 }"
		/>
	</div>
</template>
<style lang="scss" scoped>
.chart {
	width: 800px;
}
</style>
